<ng-container *ngIf="fetchedCategories$ | async as categories">
  <ng-container *ngIf="categories && categories.length">
    <div class="category-list-container my-5" [ngClass]="contentlet.cssClass">
      <h2 class="title" *ngIf="contentlet.categoryTitle">
        {{ contentlet.categoryTitle }}
      </h2>
      <custom-dot-cms-category-tile [categories]="categories" [contentlet]="contentlet"></custom-dot-cms-category-tile>
    </div>
  </ng-container>
</ng-container>
